<div class="card" [ngClass]="cardClasses">
  @if (config?.title) {
    <div class="card-title">{{ config.title | translate }}</div>
  }
  @if (config?.description) {
    <div class="card-description">{{config.description | translate}}</div>
  }
  <ng-content></ng-content>
</div>
